// extracted by mini-css-extract-plugin
export default {"alreadyHaveAccount":"recoverPassword_alreadyHaveAccount__tgh0w","successIcon":"recoverPassword_successIcon__u0GA2","confirmationText":"recoverPassword_confirmationText__uL4du"};